export enum UserRoles {
  COMPANY = "COMPANY",
  INSPECTOR = "INSPECTOR",
  QC = "QC",
  ADMIN = "ADMIN",
  CLIENT = "CLIENT",
  SUPERVISOR = "SUPERVISOR",
  MARKETING = "MARKETING",
  ASSISTANT = "ASSISTANT",
  ORDER_DATA_ENTRY = "ORDER_DATA_ENTRY",
  FINANCE = "FINANCE",
  FACILITY = "FACILITY",
  ASSIGNMENT_OFFICE = "ASSIGNMENT_OFFICE",
  INSPECTOR_ACTIVATION_OFFICE = "INSPECTOR_ACTIVATION_OFFICE",
  INSPECTION_MANAGER = "INSPECTION_MANAGER",
  SUPERVISOR_QC = "SUPERVISOR_QC"
}
